/**
 * API Configuration
 * Centralised API base URL for the Pravara InfoTech frontend.
 * Set REACT_APP_API_URL in your .env file to override.
 */

// Base API URL - reads from environment variable, or detects current hostname, or defaults to production
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (typeof window !== 'undefined' && window.location && window.location.hostname) {
    const hostname = window.location.hostname;
    if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
      return `${window.location.protocol}//${window.location.host}/api`;
    }
  }
  return 'https://pravarainfotech.in/api';
};

export const API_BASE_URL = getApiBaseUrl();

// Backend root URL (without /api) - used for accessing uploaded files
export const BACKEND_URL = API_BASE_URL.replace(/\/api\/?$/, '');

/**
 * Build a full URL to an uploaded file served by the backend.
 * @param {string} filePath - relative path, e.g. "uploads/services/1/image.jpg"
 * @returns {string} absolute URL
 */
export function getUploadUrl(filePath) {
  if (!filePath) return '';
  if (filePath.startsWith('http')) return filePath;
  return `${BACKEND_URL}/${filePath.replace(/^\//, '')}`;
}

export default API_BASE_URL;
